import React, { useState } from "react";
import "./DilemaUniques.css";
import { IMG_URL } from "../../config";

function DilemaUniques({DilemmaTypes}) {

   const [activeIndex, setActiveIndex] = useState(0);

  return (

    <div className="row dilema-uniq-row">

      {DilemmaTypes?.map((item, index) => (
        
          <div className="col-md-3" key={index}>
            <div className="dilema-uniq-card">

               <button
                  className={activeIndex === index ? "active-btn" : ""}
                  onClick={() => setActiveIndex(index)}
                >
                {item.letter_icon && (
                  <span>
                    <img src={`${IMG_URL}/d0/${item.letter_icon}`} alt={item.letter_name} />
                  </span>
                )}

                <h6>{item.letter_name}</h6>
              </button>

              <p>{item.letter_description}</p>

            </div>
          </div>
        ))}

    </div>
  );
}

export default DilemaUniques;
